import React from 'react';
import Image from 'react-bootstrap/Image';
import './ProductHeaderImage.css';

const productHeaderImage = (props) => {
    return (
        <div>
            <Image
                src={props.src}
                className={'figure-img img-fluid product-header-image'}
            />
        </div>
    )
};
export default productHeaderImage;